<template>
    <div>
        <v-container px-3 px-md-0>
            <v-row class="justify-space-between">
                <v-col v-if="!selectedField" cols="12">Prvo je potrebno odabrati željeni smjer kako bi ste mogli dodavati odjele.</v-col>
                <v-col cols="12" sm="4" v-if="currentSchool">
                    <v-autocomplete
                        :value="selectedField"
                        label="Smjer"
                        placeholder="Odaberite smjer"
                        item-value="pivot.id"
                        item-text="name"
                        outlined
                        dense
                        height="44"
                        :items="currentSchool.educational_fields"
                        @change="changeSchoolField">
                    </v-autocomplete>
                </v-col>
                <v-col v-if="selectedField" cols="12" sm="4">
                    <v-autocomplete
                        item-value="id"
                        item-text="text"
                        label="Razred"
                        outlined
                        dense
                        height="44"
                        v-model="selectedClass"
                        :items="classes"
                        @change="changeClassFilter"
                    />
                </v-col>
                <v-col v-if="selectedField" cols="12" sm="4">
                    <v-btn
                        color="primary"
                        dark
                        block
                        depressed
                        height="44"
                        class="text-none"
                        @click="showAddForm()"
                        v-if="$checkPermission('departments create')"
                    >
                        <v-icon left size="20">mdi-plus</v-icon>
                        Dodaj
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="items.length">
                <v-col v-for="(item, index) in items" :key="index" cols="12" md="4" sm="6">
                    <v-card
                        class="mx-auto"
                        max-width="364"
                        outlined
                        @click="handleAction(item)"
                    >
                        <v-list-item three-line>
                            <v-list-item-avatar
                                tile
                                size="64"
                                color="rgba(0, 0, 0, 0.6)"
                                class="white--text rounded red darken-1"
                                style="font-size: 24px;"
                            >
                                {{ item.label ? item.label : '-' }}
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold" style="overflow: initial; white-space: normal">{{currentSchool.name}}</v-list-item-title>
                                <v-list-item-subtitle style="font-size: 14px;">Razrednik: {{ item.headroom_teacher ? item.headroom_teacher.full_name : '-' }}</v-list-item-subtitle>
                                <v-list-item-subtitle style="font-size: 14px;">{{item.users_count}} učenika </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-else class="justify-center text--disabled"><span>Za tražene pojmove nema rezultata pretrage.</span></v-row>
        </v-container>
        <v-pagination
            v-if="items.length > 0"
            v-model="page"
            class="my-4"
            :length="length"
            :total-visible="5"
            @input="getDataFromApi"
        ></v-pagination>
    </div>
</template>

<script>
    import {serverBus} from "../../main";
    import ApiV2 from "@/services/ApiV2";

    export default {
        mounted: function () {
            this.getDataHeadersFromApi();
        },

        created() {
            serverBus.$on('perform-search', (search_value) => {
                this.search = search_value;
            });

            serverBus.$on('filters-changed', (filters) => {
                this.options.filters = filters;
            });

            serverBus.$on('edit-item', (item) => {
                this.editItem(item);
            });

            serverBus.$on('delete-item', (item) => {
                this.deleteItem(item);
            });

            serverBus.$on('reload-all-data', () => {
                this.$store.dispatch("setSchoolFieldId", null)
                this.items = [];
                this.getDataFromApi();
            });

            this.getDataFromApi();
        },
        computed: {
            currentSchool() {
                return this.$store.getters.getSchool;
            },
            selectedField() {
                return this.$store.getters.getSchoolFieldId;
            },
            selectedClass: {
              get() {
                return this.$store.getters.getSchoolClassId
              },
              set(value) {
                this.$store.commit('setSchoolClassId', value)
              }
            },
            classes() {
                let classNames = [
                    {
                        id: 0,
                        text: 'Svi razredi'
                    }
                ];

                switch(this.currentSchool.type){
                    case 'Osnovna škola':
                        classNames.push({header: 'Osnovna škola'});
                        for(let i = 1; i <= 9; i++){
                            classNames.push({id: i.toString(), text: `${i}. razred`})
                        }
                        break;
                    case 'Srednja škola':
                        classNames.push({header: "Srednja škola"});
                        for(let i = 1; i <= 4; i++){
                            classNames.push({id: (i + 10).toString(), text: `${i}. razred`})
                        }
                        break;
                }
                return classNames;
            },
        },
        methods: {

            getDataFromApi() {
                this.loading = true;
                const classFilter = (this.selectedClass) ? this.selectedClass : undefined;

                let params = {
                    page: this.page,
                    perPage: this.perPage,
                    sortBy: ['label'],
                    sortDesc: [false],
                    with: ['headroomTeacher'],
                    withCount: ['users'],
                    "filter[label]": `~=${this.search.phrase}`,
                    filter: {
                        school_class: classFilter
                    }
                };

                if(!this.selectedField) return;

                ApiV2.get(`school_educational_fields/${this.selectedField}/departments`, {
                        params: params
                    } 
                ).then(response => {
                    this.items = response.data.data;
                    this.length = response.data.last_page;

                    this.$store.commit('setData', this.items);
                }).finally(() => {
                    this.loading = false
                });

            },
            getDataHeadersFromApi() {
                this.loading = true;

                this.$axios.post(this.$getTable() + '/zaglavlje').then(response => {
                    this.headers = response.data;

                    serverBus.$emit('headers-change', this.headers)
                }).finally(() => {
                    this.loading = false
                });
            },
            
            showAddForm() {
                serverBus.$emit('show-department-add-form', {id: -1});
            },

            changeSchoolField(schoolFieldId) {
                this.$store.dispatch("setSchoolFieldId", schoolFieldId);
                this.$store.dispatch("setSchoolClassId", 0);
                this.getDataFromApi();
            },

            changeClassFilter(classId) {
                this.$store.dispatch("setSchoolClassId", classId);
                this.getDataFromApi()
            },

            handleAction(item) {
                serverBus.$emit("show-department-profile", item);
            },

            readItem(table, resourceId) {
                let resource = {id: resourceId};

                serverBus.$emit('show-add-edit-dialog', table, resource);
            },

            editItem(item) {
                serverBus.$emit('show-add-form', item);
            },

            deleteItem(item) {
                serverBus.$emit('show-delete-item-dialog', this.$getTable(), item);
            }
        },

        watch: {
            options: {
                handler() {
                    /*
                    if (this.options.itemsPerPage === -1) {
                        serverBus.$emit('show-all-rows-warning');
                        return;
                    }
                     */

                    this.getDataFromApi();
                },
                deep: true
            },

            search: {
                handler() {
                    if (this.search.field !== null && this.search.phrase !== null) {
                        let self = this;

                        self.loading = true;

                        clearTimeout(self.request);

                        self.request = null;
                        self.request = setTimeout(function () {
                            self.options.search = self.search;
                            self.getDataFromApi();
                        }, 300);
                    }
                },
                deep: true
            },

            selectedClass: {
                handler() {
                    this.page = 1
                    this.getDataFromApi()
                },
                deep: true
            }
        },

        beforeDestroy() {
            this.$destroyEvents();

            serverBus.$off('perform-search');
            serverBus.$off('filters-changed');
            serverBus.$off('edit-item');
            serverBus.$off('delete-item');
            serverBus.$off('reload-all-data');
            serverBus.$off('reload-table-data');
        },

        data: function () {
            return {
                items: [],
                request: null,
                // selectedClass: 0,
                search: {
                    phrase: '',
                    field: null
                },
                options: {
                    filters: {}
                },
                loading: true,
                page: 1,
                perPage: 15,
                length: 1,
                totalVisible: 3,
            }
        },

    }
</script>
